import { v1 } from 'app/api';

import { DocumentAttributesMap } from 'app/models';
import { RecognizeApiModel } from './types';

//----------------------------------------------------------
// /recognize/process
//----------------------------------------------------------
export async function recognizeProcess<T extends keyof DocumentAttributesMap>({
	documentType,
	documentFile,
}: RecognizeApiModel.ProcessRequest): Promise<RecognizeApiModel.ProcessResponseData<T>> {
	const form = new FormData();

	form.append('doc_type', documentType);
	form.append('document', documentFile);

	const response = await v1.post<RecognizeApiModel.ProcessResponse<T>>('/recognize/process', form);
	return response.data.data;
}
